import React, { Fragment, useEffect, useState } from "react";
import ReactModal from "react-modal";
import axios from "axios";
//impoertacion componentes
import img from "../Loader/spinner.gif";

function AutoevaluacionOm(props) {
  const [isLoading, setLoading] = useState(false);

  const [modalIsOpen, setIsOpen] = useState(false);
  const handleOpenModalTest = () => {
    setIsOpen(true);
  };
  const closeModal = () => {
    setIsOpen(false);
  };

  const [postNumeroOm, setPostNumeroOm] = useState([]);
  const [postTitulo, setPostTitulo] = useState([]);
  const [postTexto, setPostTexto] = useState([]);
  const [postAccion, setPostAccion] = useState([]);
  const [postElementoVerificacion, setPostElementoVerificacion] = useState([]);

  const postData = (e) => {
    e.preventDefault(e);
    axios({
      method: "post",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/CreaOmEstandarAsistencial",
      data: {
        numeroOm: postNumeroOm,
        texto: postTexto,
        accion: postAccion,
        elementoVerificacion: postElementoVerificacion,
        titulo: postTitulo,
        solicitudId: props.idSolicitud,
      },
    })
      .then((Response) => {
        console.log(Response.data);
        window.location.reload("/");
        window.alert("creado");
      })
      .catch((error) => {
        console.log(error);
        alert("Error al crear" + error);
      });
  };
  return (
    <div className="test">
      <button
        variant="contained"
        className="btn btn-primary "
        color="primary"
        onClick={handleOpenModalTest}
      >
        {" "}
        Nueva Om
      </button>
      <hr />
      <ReactModal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Crear Institucion"
      >
        <div className="container">
          <div className="text-center">
            <div class="container-fluid">
              <div class="card shadow mb-4">
                <div class="card-header py-3">
                  <h6 class="m-0 font-weight-bold text-primary">
                    Crear Oportunidad de mejora
                  </h6>
                </div>
                <div class="card-body">
                  <div class="table-responsive"></div>
                  <form className="user">
                    <div className="form-group row">
                      <div className="col-sm-12">
                        <input
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Numero Om"
                          onChange={(e) => setPostNumeroOm(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="form-group row">
                      <div className="col-sm-12">
                        <select
                          className="btn btn-secondary btn-user btn-block text-left"
                          onChange={(e) => setPostTitulo(e.target.value)}
                        >
                          <option value="">seleccione tipo de om</option>
                          <option value="34">Om Humanización atención </option>
                          <option value="35">Om seguridad del paciente </option>
                          <option value="36">Om Gestion tecnologia </option>
                          <option value="37">
                            Om Enfoque gestion de riesgo{" "}
                          </option>
                          <option value="38">
                            Om Transformacion cultural{" "}
                          </option>
                          <option value="39">Om Responsabilidad social </option>
                          <option value="40">
                            Om Procesode atención al cliente asistencial
                            ambulatorio y hospitalario{" "}
                          </option>
                          <option value="41">
                            Om Mejoramiento de la calidad{" "}
                          </option>
                        </select>
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-12">
                        <textarea
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Texto de la Om"
                          onChange={(e) => setPostTexto(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="form-group row">
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <textarea
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Acciones de mejora"
                          onChange={(e) => setPostAccion(e.target.value)}
                        />
                      </div>
                      <div className="col-sm-6 mb-3 mb-sm-0">
                        <textarea
                          type="text"
                          className="form-control form-control-user"
                          placeholder="Elementos de verificación"
                          onChange={(e) =>
                            setPostElementoVerificacion(e.target.value)
                          }
                        />
                      </div>
                    </div>

                    {isLoading ? (
                      ""
                    ) : (
                      <a>
                        <button
                          className="btn btn-primary btn-user btn-block "
                          onClick={postData}
                        >
                          Guardar
                        </button>
                      </a>
                    )}
                    {isLoading ? (
                      <div>
                        <img
                          style={{ width: "200px", height: "200px" }}
                          src={img}
                        />{" "}
                      </div>
                    ) : (
                      ""
                    )}
                    <hr />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ReactModal>
    </div>
  );
}
export default AutoevaluacionOm;
